import _last from 'lodash/last'

/*
 * tabChanged will check if tab changed when LOCATION_CHANGE is triggered
 * if tab changed we reset to initialState, return currentState otherwise
 * we should think in another way to handle this multiple reducers for sub-components
 * maybe with a giant reducer related to the scene
 * at the moment we don't have enough time to do a refactor
 * this is the "best" but worst solution to the problem 😭
 */
export const tabChanged = (payload, currentTab, currentState, initialState) => {
  const newTab = _last(payload.pathname.split('/'))
  return newTab === currentTab ? currentState : initialState
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/utils.js